import { RefObject } from "react";

import { Icon, InfoCircleFilledSVG } from "@newsela/angelou";
import { useRouter } from "next/router";

import { EventProperties } from "@/types/models/EventProperties.interface";
import PanelHeader from "@/view/PanelHeader";
import {
  iconCss,
  messageContainerCss,
  textCss,
  titleCss,
} from "./ChecksForUnderstandingStudentContainer.style";

interface IProps {
  closeButtonEventProperties: EventProperties;
  onClickCloseButton: () => void;
  shouldFocusCloseButtonRef: RefObject<boolean>;
}

export const ChecksForUnderstandingStudentContainer = ({
  closeButtonEventProperties,
  onClickCloseButton,
  shouldFocusCloseButtonRef,
}: IProps) => {
  const router = useRouter();
  const { query: levelId } = router || {};

  const backButtonEventProperties = {
    objectType: "Quiz",
    actionName: "Navigate",
    streamProperties: {
      content_type: "Article",
      description:
        "Navigate back to Activity Picker from checks for understanding quiz",
      content_id: levelId,
    },
  };

  const onClickBackButton = () => {
    const query = { ...router.query };
    delete query?.["activityPanel"];
    void router.replace({ pathname: router.pathname, query }, undefined, {
      shallow: true,
    });
  };

  return (
    <>
      <PanelHeader
        onClickBackButton={onClickBackButton}
        onClickCloseButton={onClickCloseButton}
        closeButtonEventProperties={closeButtonEventProperties}
        backButtonEventProperties={backButtonEventProperties}
        shouldFocusCloseButtonRef={shouldFocusCloseButtonRef}
      >
        <h2 css={titleCss}>Checks For Understanding</h2>
      </PanelHeader>
      <div css={messageContainerCss}>
        <div>
          <Icon
            SvgComponent={InfoCircleFilledSVG}
            __cssFor={{
              root: iconCss,
            }}
          />
        </div>
        <div css={textCss}>
          Correctly answer the questions that appear as you read to unlock more
          text. When you’ve completed all of the questions, move on to the other
          assigned activities.
        </div>
      </div>
    </>
  );
};

export default ChecksForUnderstandingStudentContainer;
